<template>
  <div class="disciplinaryMeasure">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Disciplinary Case</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Disciplinary Case</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <a @click="openDialog" class="btn add-btn"
                  ><i class="fa fa-plus"></i> Add Disciplinary Case</a
                >
              </div>
            </div>
          </div>
          <!-- /Page Header -->
          <!----Datatable-->
          <div class="row">
            <div class="col-md-12">
              <div class="table-responsive">
                <v-data-table
                  :headers="headers"
                  :items="disciplinaryCases"
                  sort-by=""
                  class="elevation-1"
                >
                  <template v-slot:[`item.actions`]="{ item }">
                    <div class="dropdown dropdown-action">
                      <a
                        href="#"
                        class="action-icon dropdown-toggle"
                        data-toggle="dropdown"
                        aria-expanded="false"
                        ><i class="material-icons">more_vert</i></a
                      >
                      <div class="dropdown-menu dropdown-menu-right">
                        <a
                          class="dropdown-item"
                          @click="setDetailDisciplinaryCase(item)"
                          ><i class="fa fa-pencil m-r-5"></i> Detail</a
                        >
                        <a
                          class="dropdown-item"
                          @click="setEditDisciplinaryCase(item)"
                          ><i class="fa fa-pencil m-r-5"></i> Edit</a
                        >
                        <a
                          class="dropdown-item"
                          @click="setDeleteDisciplinaryCase(item)"
                          ><i class="fa fa-trash-o m-r-5"></i> Delete</a
                        >
                      </div>
                    </div>
                  </template>
                  <template v-slot:[`item.profile`]="{ item }">
                    <h2 class="table-avatar">
                      {{
                        item.accusedEmployees.length > 1
                          ? `${item.accusedEmployees[0].employee.firstName} ${item.accusedEmployees[0].employee.lastName} and others`
                          : item.accusedEmployees.length == 1
                          ? `${item.accusedEmployees[0].employee.firstName} ${item.accusedEmployees[0].employee.lastName}`
                          : `No employee added`
                      }}
                    </h2>
                  </template>
                  <template v-slot:[`item.reas`]="{ item }">
                    {{ item.reason | truncate(150, "...") }}
                  </template>
                  <template v-slot:[`item.date`]="{ item }">
                    {{ new Date(item.date).toLocaleDateString() }}
                  </template>
                  <template v-slot:[`item.createdAt`]="{ item }">
                    {{ new Date(item.createdAt).toLocaleDateString() }}
                  </template>
                </v-data-table>
              </div>
            </div>
          </div>
          <!---/Datatable-->
        </div>
        <!-- /Page Content -->

        <!-- Add disciplinaryCase Modal -->
        <v-dialog v-model="dialog" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Add Disciplinary Case</h5>
              <button type="button" class="close" @click="close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="onSubmit">
                <div class="row">
                  <div class="col-md-12">
                    <div
                      class="alert alert-danger alert-dismissible fade show"
                      role="alert"
                      v-if="error"
                    >
                      <strong>Error!</strong> {{ error }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div
                      class="alert alert-success alert-dismissible fade show"
                      role="alert"
                      v-if="message"
                    >
                      <strong>Success!</strong> {{ message }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label>Title <span class="text-danger">*</span></label>
                  <input class="form-control" v-model="title" />
                </div>
                <div class="form-group leave-duallist">
                  <div class="col-sm-6 col-md-6">
                    <div class="form-group form-focus">
                      <input
                        type="text"
                        class="form-control floating"
                        v-model="filterEmpName"
                        style="height: 55px !important"
                      />
                      <label class="focus-label">Employee Name</label>
                    </div>
                  </div>
                  <label>Add Accused Employee</label>
                  <div class="row">
                    <div class="col-lg-5 col-sm-5">
                      <select
                        id="customleave_select"
                        v-model="pickEmployees"
                        class="form-control"
                        size="8"
                        multiple="multiple"
                      >
                        <option
                          :value="item.id"
                          v-for="item in searchEmployeeList"
                          :key="item.id"
                          >{{ item.firstName + " " + item.lastName }}
                        </option>
                      </select>
                    </div>
                    <div class="multiselect-controls col-lg-2 col-sm-2">
                      <button
                        type="button"
                        id="customleave_select_rightAll"
                        @click="selectedAllFrom"
                        class="btn btn-block btn-white"
                      >
                        <i class="fa fa-forward"></i>
                      </button>
                      <button
                        type="button"
                        id="customleave_select_rightSelected"
                        @click="selectedFrom"
                        class="btn btn-block btn-white"
                      >
                        <i class="fa fa-chevron-right"></i>
                      </button>
                      <button
                        type="button"
                        id="customleave_select_leftSelected"
                        @click="selectedTo"
                        class="btn btn-block btn-white"
                      >
                        <i class="fa fa-chevron-left"></i>
                      </button>
                      <button
                        type="button"
                        id="customleave_select_leftAll"
                        @click="selectedAllTo"
                        class="btn btn-block btn-white"
                      >
                        <i class="fa fa-backward"></i>
                      </button>
                    </div>
                    <div class="col-lg-5 col-sm-5">
                      <select
                        id="customleave_select_to"
                        class="form-control"
                        size="8"
                        multiple="multiple"
                      ></select>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label
                    >Date of Event <span class="text-danger">*</span></label
                  >
                  <div class="cal-icon">
                    <datepicker
                      v-model="date"
                      calendar-class
                      input-class
                      bootstrap-styling
                      class="form-control datetimepicker"
                      type="text"
                    />
                  </div>
                </div>
                <div class="form-group">
                  <label>Accusation <span class="text-danger">*</span></label>
                  <textarea
                    class="form-control"
                    v-model="reason"
                    rows="4"
                  ></textarea>
                </div>
                <div class="submit-section">
                  <button
                    data-dismiss="modal"
                    class="btn btn-primary submit-btn"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>
        <!-- /Add disciplinaryCase Modal -->

        <!-- Detail disciplinaryCase Modal -->
        <v-dialog v-model="dialogDetail" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Disciplinary Case</h5>
              <button type="button" class="close" @click="closeDetail">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label>Title <span class="text-danger">*</span></label>
                <input
                  class="form-control"
                  v-model="disciplinaryCase.title"
                  disabled
                />
              </div>
              <div class="form-group leave-duallist">
                <label class="col-md-7">Select Employee</label>
                <label class="col-md-4">Accused Employee</label>

                <div class="row">
                  <div class="col-lg-5 col-sm-5">
                    <select
                      id="customleave_select"
                      v-model="selectedEmployees"
                      class="form-control"
                      size="8"
                      multiple="multiple"
                      disabled
                    >
                      <option
                        :value="item.id"
                        v-for="item in employees"
                        :key="item.id"
                        >{{ item.firstName + " " + item.lastName }}
                      </option>
                    </select>
                  </div>
                  <div class="multiselect-controls col-lg-2 col-sm-2">
                    <button
                      type="button"
                      id="customleave_select_rightAll"
                      @click="selectedAllFrom"
                      disabled
                      class="btn btn-block btn-white"
                    >
                      <i class="fa fa-forward"></i>
                    </button>
                    <button
                      type="button"
                      id="customleave_select_rightSelected"
                      @click="selectedFrom"
                      disabled
                      class="btn btn-block btn-white"
                    >
                      <i class="fa fa-chevron-right"></i>
                    </button>
                    <button
                      type="button"
                      id="customleave_select_leftSelected"
                      @click="selectedTo"
                      disabled
                      class="btn btn-block btn-white"
                    >
                      <i class="fa fa-chevron-left"></i>
                    </button>
                    <button
                      type="button"
                      id="customleave_select_leftAll"
                      @click="selectedAllTo"
                      disabled
                      class="btn btn-block btn-white"
                    >
                      <i class="fa fa-backward"></i>
                    </button>
                  </div>
                  <div class="col-lg-5 col-sm-5">
                    <select
                      id="customleave_select_to"
                      class="form-control"
                      size="8"
                      multiple="multiple"
                    ></select>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label>Date of Event <span class="text-danger">*</span></label>
                <div class="cal-icon">
                  <datepicker
                    v-model="disciplinaryCase.date"
                    calendar-class
                    input-class
                    bootstrap-styling
                    class="form-control datetimepicker"
                    type="text"
                    disabled
                  />
                </div>
              </div>
              <div class="form-group">
                <label>Accusation <span class="text-danger">*</span></label>
                <textarea
                  class="form-control"
                  v-model="disciplinaryCase.accusation"
                  rows="4"
                  disabled
                ></textarea>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Edit disciplinaryCase Modal -->
        <!-- Edit disciplinaryCase Modal -->
        <v-dialog v-model="dialogEdit" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Edit Disciplinary Case</h5>
              <button type="button" class="close" @click="closeEdit">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="updateDisciplinaryCase">
                <div class="form-group">
                  <label>Title <span class="text-danger">*</span></label>
                  <input
                    class="form-control"
                    v-model="disciplinaryCase.title"
                  />
                </div>
                <div class="form-group leave-duallist">
                  <label>Add Accused Employee</label>
                  <div class="row">
                    <div class="col-lg-5 col-sm-5">
                      <select
                        id="customleave_select"
                        v-model="pickEmployees"
                        class="form-control"
                        size="8"
                        multiple="multiple"
                      >
                        <option
                          :value="item.id"
                          v-for="item in employees"
                          :key="item.id"
                          >{{ item.firstName + " " + item.lastName }}
                        </option>
                      </select>
                    </div>
                    <div class="multiselect-controls col-lg-2 col-sm-2">
                      <button
                        type="button"
                        id="customleave_select_rightAll"
                        @click="selectedAllFrom"
                        disabled
                        class="btn btn-block btn-white"
                      >
                        <i class="fa fa-forward"></i>
                      </button>
                      <button
                        type="button"
                        id="customleave_select_rightSelected"
                        @click="selectedFrom"
                        disabled
                        class="btn btn-block btn-white"
                      >
                        <i class="fa fa-chevron-right"></i>
                      </button>
                      <button
                        type="button"
                        id="customleave_select_leftSelected"
                        @click="selectedTo"
                        class="btn btn-block btn-white"
                      >
                        <i class="fa fa-chevron-left"></i>
                      </button>
                      <button
                        type="button"
                        id="customleave_select_leftAll"
                        @click="selectedAllTo"
                        class="btn btn-block btn-white"
                      >
                        <i class="fa fa-backward"></i>
                      </button>
                    </div>
                    <div class="col-lg-5 col-sm-5">
                      <select
                        id="customleave_select_to"
                        class="form-control"
                        size="8"
                        multiple="multiple"
                      ></select>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label
                    >Date of Event <span class="text-danger">*</span></label
                  >
                  <div class="cal-icon">
                    <datepicker
                      v-model="disciplinaryCase.date"
                      calendar-class
                      input-class
                      bootstrap-styling
                      class="form-control datetimepicker"
                      type="text"
                    />
                  </div>
                </div>
                <div class="form-group">
                  <label>Accusation <span class="text-danger">*</span></label>
                  <textarea
                    class="form-control"
                    v-model="disciplinaryCase.accusation"
                    rows="4"
                  ></textarea>
                </div>
                <div class="submit-section">
                  <button
                    @click.prevent="updateDisciplinaryMeasure"
                    class="btn btn-primary submit-btn"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>
        <!-- /Edit disciplinaryCase Modal -->

        <!-- Delete disciplinaryCase Modal -->
        <v-dialog v-model="dialogDelete" max-width="725px">
          <div class="modal-content">
            <div class="modal-body">
              <div class="form-header">
                <button type="button" class="close" @click="closeDelete">
                  <span aria-hidden="true">&times;</span>
                </button>
                <h3>Delete disciplinaryMeasure</h3>
                <p>Are you sure want to delete?</p>
              </div>
              <div class="modal-btn delete-action">
                <div class="row">
                  <div class="col-6">
                    <a
                      @click.prevent="deleteDisciplinaryMeasure"
                      class="btn btn-primary continue-btn"
                      data-dismiss="modal"
                      >Delete</a
                    >
                  </div>
                  <div class="col-6">
                    <a
                      href="javascript:void(0);"
                      data-dismiss="modal"
                      @click="closeDelete"
                      class="btn btn-primary cancel-btn"
                      >Cancel</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Delete disciplinaryCase Modal -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/employeeSidebar.vue";
import { required, sameAs } from "vuelidate/lib/validators";
import { employeeService } from "@/services/employeeService.js";
import Datepicker from "vuejs-datepicker";
import { authenticationService } from "@/services/authenticationService";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Datepicker
  },

  data() {
    return {
      dialog: false,
      dialogEdit: false,
      dialogDelete: false,
      dialogDetail: false,
      headers: [
        { text: "Accused Employees", value: "profile" },
        { text: "Accusation Title", value: "accusation" },
        { text: "Date of Event", value: "date" },
        { text: "Reporting Date", value: "createdAt" },
        { text: "Actions", value: "actions", sortable: false }
      ],
      name: "",
      // form: "",
      employeeId: "",
      title: "",
      hrManager: "",
      message: "",
      error: "",
      reason: "",
      date: "",
      disciplinaryCase: {},
      disciplinaryCases: [],
      filterEmpName: "",
      employee: {},
      loading: false,
      error: "",
      employees: [],
      selectedEmployees: [],
      pickEmployees: [],
      submitted: false,
      queries: [],
      //employee: authenticationService.currentOfficeValue,
      company: authenticationService.currentOfficeValue,
      user: authenticationService.currentUserValue
    };
  },

  validations: {
    name: { required },
    reason: { required },
    date: { required }
    //disciplinaryMeasureDate: { required },
  },

  computed: {
    searchEmployeeList: function() {
      return this.employees.filter(d =>
        this.filterEmpName != ""
          ? d.firstName
              .toLowerCase()
              .includes(this.filterEmpName.toLowerCase()) ||
            d.lastName.toLowerCase().includes(this.filterEmpName.toLowerCase())
          : true
      );
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    dialogEdit(val) {
      val || this.closeEdit();
    }
  },
  methods: {
    getEmployees() {
      const companyId = this.company.id;
      //console.log('this.company.id', this.company.id)
      employeeService.getEmployees(companyId).then(
        model => {
          this.employees = model;
          // console.log(model)
        },
        error => {
          error = error;
        }
      );
    },
    openDialog() {
      this.dialog = true;
      this.sortEmployee();
    },
    close() {
      this.dialog = false;
      this.clearList();
    },
    closeEdit() {
      this.dialogEdit = false;
    },
    closeDetail() {
      this.dialogDetail = false;
    },
    closeDelete() {
      this.dialogDelete = false;
    },
    clearList() {
      this.employeeId = "";
      this.reason = "";
      this.title = "";
      this.pickEmployees = "";
      this.date = "";
      this.selectedEmployees.pop();
    },

    sortEmployee() {
      function compare(a, b) {
        if (a.firstName.toLowerCase() < b.firstName.toLowerCase()) return -1;
        if (a.firstName.toLowerCase() > b.firstName.toLowerCase()) return 1;
        return 0;
      }

      return this.employees.sort(compare);
    },
    setEditDisciplinaryCase(model) {
      this.disciplinaryCase = model;
      this.selectedEmployees = model.accusedEmployees.map(
        item => item.employeeId
      );
      setTimeout(() => this.selectedFrom(), 1000);
      this.dialogEdit = true;
    },
    setDetailDisciplinaryCase(model) {
      this.disciplinaryCase = model;
      this.selectedEmployees = model.accusedEmployees.map(
        item => item.employeeId
      );
      setTimeout(() => this.selectedFrom(), 1000);
      this.dialogDetail = true;
    },
    setDeleteDisciplinaryCase(model) {
      this.disciplinaryCase = model;
      this.dialogDelete = true;
    },
    selectedAllFrom() {
      var selectOption = [];
      $(document)
        .find("#customleave_select")
        .find("option")
        .each(function() {
          selectOption.push(this);
        });

      $(document)
        .find("#customleave_select_to")
        .append(selectOption);
      this.selectedEmployees = this.employees;
    },
    selectedFrom() {
      var selectOption = [];
      $(document)
        .find("#customleave_select")
        .find("option:selected")
        .each(function() {
          selectOption.push(this);
        });
      this.selectedEmployees.push(this.pickEmployees[0]);
      $(document)
        .find("#customleave_select_to")
        .append(selectOption);

      // console.log(this.selectedEmployees)
    },
    selectedAllTo() {
      var selectOption = [];
      $(document)
        .find("#customleave_select_to")
        .find("option")
        .each(function() {
          selectOption.push(this);
        });

      $(document)
        .find("#customleave_select")
        .append(selectOption);

      this.selectedEmployees = [];
    },
    selectedTo() {
      var selectOption = [];
      var values = [];
      $(document)
        .find("#customleave_select_to")
        .find("option:selected")
        .each(function() {
          selectOption.push(this);
          values.push($(this).val());
        });

      $(document)
        .find("#customleave_select")
        .append(selectOption);

      values.forEach(v => {
        var data = JSON.parse(JSON.stringify(this.selectedEmployees));
        var index = data.indexOf(parseInt(v));
        data.splice(index, 1);
        this.selectedEmployees = data;
        // console.log(this.selectedEmployees)
      });
    },
    getDisciplinaryCases() {
      //const user = this.user;
      // console.log(`company`, this.company.id)
      employeeService
        .getDisciplinaryCaseByEmployeeId(this.user.employee.id)
        .then(
          model => {
            this.disciplinaryCases = model;
            // console.log(`model`, model)
          },
          error => {
            error = error;
          }
        );
    },
    onSubmit() {
      this.submitted = true;

      if (this.reason == "") {
        return (this.error = "Enter Complain reasons");
      }

      this.loading = true;
      let accusedEmployees = this.selectedEmployees.map(item => ({
        employeeId: item
      }));
      employeeService
        .addDisciplinaryCase(
          this.company.id,
          this.title,
          this.date,
          this.reason,
          null,
          null,
          this.user.employee.id,
          accusedEmployees
        )
        .then(
          id => {
            employeeService
              .getDisciplinaryCaseByEmployeeId(this.user.employee.id)
              .then(w => {
                this.disciplinaryCases = w;
                // console.log(w);
                this.close();
                this.clearList();
              });
          },
          error => {
            this.error = error;
            this.loading = false;
          }
        );
    },
    updateDisciplinaryMeasure() {
      this.submitted = true;

      this.loading = true;
      // console.log(this.disciplinaryMeasure)
      employeeService.updateDisciplinaryCase(this.disciplinaryCase).then(
        id => {
          employeeService
            .getDisciplinaryCaseByEmployeeId(this.user.employee.id)
            .then(o => {
              (this.disciplinaryCases = o),
                //console.log(o),
                this.closeEdit();
            });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },
    deleteDisciplinaryMeasure() {
      const id = this.disciplinaryCase.id;
      // console.log(this.disciplinaryMeasure)
      employeeService.removeDisciplinaryCase(id).then(id => {
        employeeService
          .getDisciplinaryCaseByEmployeeId(this.user.employee.id)
          .then(
            model => {
              this.disciplinaryCases = model;
              // console.log(model)
              this.closeDelete();
            },
            error => {
              error = error;
            }
          );
      });
    }
  },

  mounted() {
    this.getEmployees();
    this.getDisciplinaryCases();

    // Datatable
    //this.getEmployees(this.employee.id);
    //this.getEmployeedisciplinaryMeasures(this.company.id);

    if ($(".datatable").length > 0) {
      $(".datatable").DataTable({
        bFilter: false
      });
    }
    $(document).on("change", "#customleave_select", function() {
      //$(this).find('option:selected')
      return false;
    });
    // Date Time Picker

    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "employeedisciplinarycase"
};
</script>



// WEBPACK FOOTER //
// src/components/discipline/employeeDisciplinaryCase.vue